import React from 'react';
import AddPhotoAlternate from '@material-ui/icons/AddPhotoAlternateOutlined';

const styles = {
  container: {
    fontSize: 'small',
    textAlign: 'center',
    minWidth: '100px'
  },
  labelContainer: {
    padding: '16px'
  },
  label: {
    cursor: 'pointer'
  }
}

const ImageSelector = (props) => {
  const { imgSrc, ...restProps } = props;

  const encodeBase64 = (elm) => {
    console.log('[ImageSelector # encodeBase64] elm:', elm);
    let file = elm.target.files[0];
    let imgReader = new FileReader();

    imgReader.onloadend = () => {
      // eslint-disable-next-line no-unused-expressions
      props.onChange?.(imgReader.result);
    };
    imgReader.readAsDataURL(file);
  }

  return (
    <div {...restProps} style={styles.container}>
      <input id="selector" hidden type="file" onChange={encodeBase64}/>
      <div style={styles.labelContainer}>
      <label style={styles.label} htmlFor="selector">
        {
          imgSrc
            ? <img src={imgSrc}/>
            : <div><AddPhotoAlternate/></div>
        }
      </label>
      </div>
      Actual Size
    </div>
  );
};

export default ImageSelector;
